/**
 * Meta Store
 * A store for managing lifecycle methods and other
 * default behavior for other stores.
 */

"use strict";

exports.__esModule = true;
exports["default"] = {

  willReset: function willReset(state, next) {
    return next;
  }

};
module.exports = exports["default"];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9zdG9yZXMvbWV0YS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7cUJBTWU7O0FBRWIsV0FBUyxFQUFBLG1CQUFDLEtBQUssRUFBRSxJQUFJLEVBQUU7QUFDckIsV0FBTyxJQUFJLENBQUE7R0FDWjs7Q0FFRiIsImZpbGUiOiJzcmMvc3RvcmVzL21ldGEuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIE1ldGEgU3RvcmVcbiAqIEEgc3RvcmUgZm9yIG1hbmFnaW5nIGxpZmVjeWNsZSBtZXRob2RzIGFuZCBvdGhlclxuICogZGVmYXVsdCBiZWhhdmlvciBmb3Igb3RoZXIgc3RvcmVzLlxuICovXG5cbmV4cG9ydCBkZWZhdWx0IHtcblxuICB3aWxsUmVzZXQoc3RhdGUsIG5leHQpIHtcbiAgICByZXR1cm4gbmV4dFxuICB9XG5cbn1cbiJdfQ==




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/stores/meta.js
 ** module id = 203
 ** module chunks = 0
 **/